import * as React from "react";
import { useTranslation } from "react-i18next";
import QueryHelper from "components/common/QueryHelper";
const QUERY_EXAMPLE = "status:FAILURE";
const ReportQueryHelper = () => {
  const { t } = useTranslation("enterprise_report");
  const queryExample = /* @__PURE__ */ React.createElement("p", null, t("report_history_query_helper.example"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, QUERY_EXAMPLE), /* @__PURE__ */ React.createElement("br", null));
  const fieldMap = {
    status: t("report_history_query_helper.status")
  };
  return /* @__PURE__ */ React.createElement(
    QueryHelper,
    {
      example: queryExample,
      entityName: t("report_history_query_helper.entity_name"),
      commonFields: [],
      fieldMap
    }
  );
};
export default ReportQueryHelper;
